import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useVenueContext } from '@/providers/VenueProvider';

/**
 * Captures the {@code :slug} URL parameter into {@link VenueProvider}.
 *
 * <p>Used by the entry-point components under {@code /venue/:slug/*}
 * ({@code VenueDetailPage}, {@code HomePage}, {@code AvailabilityPage}) so
 * every time a customer lands on a venue's pages we pin that slug for the
 * rest of their session. Navigation outside the venue subtree
 * ({@code /my-bookings}, {@code /credits}) then routes "Book Again" / "Book
 * Now" back to the correct venue.
 *
 * <p>No-op when {@code :slug} isn't in the current URL scope.
 */
export function useVenueSlugCapture() {
  const { slug } = useParams<{ slug: string }>();
  const { setCurrentSlug } = useVenueContext();

  useEffect(() => {
    if (slug) setCurrentSlug(slug);
  }, [slug, setCurrentSlug]);
}
